import {
  Button,
  Card,
  CardHeader,
  colors,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tooltip,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { delete_Faq_Category, getSingle_Page_category } from "../auth/service";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import { toast, ToastContainer } from "react-toastify";

const CardPageCategory = ({ pagecategorylist, refreshList }) => {
  const [openDialog, setOpenDialog] = useState(false);
  const navigate = useNavigate();

  const handleDeleteClick = () => {
    setOpenDialog(true); // open confirmation popupD
  };

  const handleConfirmDelete = async () => {
    setOpenDialog(false);

    try {
      console.log("page del", pagecategorylist);
      const data = await delete_Faq_Category(pagecategorylist?._id);
      toast.dismiss();
      toast.success(data?.message || "Category deleted successfully", {
        toastId: "category-delete",
      });
      console.log("test:", data);
      if (refreshList) {
        refreshList();
      }
    } catch (error) {
      toast.error("Something went wrong");
    }
  };

  const handleCancelDelete = () => {
    setOpenDialog(false);
  };

  return (
    <>
      <Card style={{ height: "100%" }}>
        <div className="box-wrapper">
          <CardHeader
            titleTypographyProps={{
              sx: {
                textTransform: "capitalize",
                color: "#000000", // ✅ will apply correctly
                fontWeight: 500,
              },
            }}
            title={
              <Tooltip title={pagecategorylist?.category || ""} arrow>
                <span
                  style={{
                    display: "inline-block",
                    maxWidth: "180px", // 👈 adjust as per your layout
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    textTransform: "capitalize",
                  }}
                >
                  {pagecategorylist?.category}
                </span>
              </Tooltip>
            }
            action={
              <>
                <EditIcon
                  // onClick={() => {
                  //   onEditCategoryMetaDetails(pagecategorylist?._id);
                  // }}
                  onClick={() => {
                    navigate("/dashboard/metatags/application-category", {
                      state: { id: pagecategorylist?._id }, // 👈 just pass the id
                    });
                  }}
                  sx={{ cursor: "pointer", mr: 1, fontSize: 20 }}
                />

                <DeleteIcon
                  onClick={handleDeleteClick}
                  sx={{ cursor: "pointer", fontSize: 20 }}
                >
                  {" "}
                </DeleteIcon>
              </>
            }
          />
        </div>
      </Card>
     
      {/* ✅ Confirmation Popup */}
      <Dialog open={openDialog} onClose={handleCancelDelete}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent sx={{ p: 3 }}>
          <p style={{ fontSize: "16px", fontFamily: "sans-serif" }}>
            Are you sure you want to delete this category:
            <b>{pagecategorylist?.category}</b>?
          </p>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={handleCancelDelete} color="primary">
            Cancel
          </Button>
          <Button
            onClick={handleConfirmDelete}
            color="error"
            variant="contained"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CardPageCategory;
